import { TranslateProvider, useTranslate } from "./translate_provider";

const locales = {
    "english": "en",
    "myanmar": "mm"
}

export { TranslateProvider, useTranslate, locales };